import type { CSSProperties } from 'react';
import { Icon } from '@/components/ui/Icon';

/** עימוד צד-שרת בכרטיס נפרד (רשימת ההקלטות): "1–4 מתוך 68" + עמודים ממוספרים. */
export function Pager({ page, lastPage, total, pageSize, count, onPage }: {
  page: number; lastPage: number; total: number; pageSize: number; count: number; onPage: (p: number) => void;
}) {
  if (total === 0) return null;
  const first = (page - 1) * pageSize + 1;
  const pages = pageList(page, lastPage);
  const nav = (disabled: boolean): CSSProperties => ({
    width: 32, height: 32, border: 0, borderRadius: 8, display: 'grid', placeItems: 'center',
    background: 'transparent', color: 'var(--text)', cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.35 : 1,
  });
  return (
    <nav aria-label="עימוד" className="card" style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', padding: '10px 16px', borderRadius: 14 }}>
      <span style={{ fontSize: 12.5, color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}>
        {first}–{first + count - 1} מתוך {total}
      </span>
      <span style={{ flex: 1 }} />
      <button type="button" className="cdr-page" aria-label="הקודם" disabled={page <= 1} onClick={() => onPage(page - 1)} style={nav(page <= 1)}>
        <Icon name="chevron" size={14} />
      </button>
      {pages.map((p, i) => p === '…' ? (
        <span key={`gap${i}`} style={{ minWidth: 24, textAlign: 'center', color: 'var(--muted)' }}>…</span>
      ) : (
        <button
          key={p}
          type="button"
          className="cdr-page"
          aria-current={p === page ? 'page' : undefined}
          onClick={() => onPage(p)}
          style={{
            minWidth: 32, height: 32, padding: '0 6px', border: 0, borderRadius: 8, cursor: 'pointer',
            fontSize: 'var(--t-sm)', fontVariantNumeric: 'tabular-nums', fontFamily: 'inherit',
            background: p === page ? 'var(--text)' : 'transparent', color: p === page ? 'var(--bg)' : 'var(--text)',
            fontWeight: p === page ? 700 : 400,
          }}
        >{p}</button>
      ))}
      <button type="button" className="cdr-page" aria-label="הבא" disabled={page >= lastPage} onClick={() => onPage(page + 1)} style={nav(page >= lastPage)}>
        <Icon name="chevron" size={14} style={{ transform: 'scaleX(-1)' }} />
      </button>
    </nav>
  );
}

function pageList(page: number, last: number): (number | '…')[] {
  if (last <= 7) return Array.from({ length: last }, (_, i) => i + 1);
  const out: (number | '…')[] = [1];
  const from = Math.max(2, page - 1);
  const to = Math.min(last - 1, page + 1);
  if (from > 2) out.push('…');
  for (let p = from; p <= to; p++) out.push(p);
  if (to < last - 1) out.push('…');
  out.push(last);
  return out;
}
